// Initialize slider
let $slider = $('.js-slider');
let $window = $(window);

let $args = {
	dots: true,
  arrows: true,
  autoplay: false, 
  pauseOnHover: true,
  prevArrow: '<button type="button" class="slider-arrow slider-prev slick-arrow slick-prev">Previous</button>',
  nextArrow: '<button type="button" class="slider-arrow slider-next slick-arrow slick-next">Previous</button>'
}

$slider.slick($args);

$window.resize(function() {
  $slider.slick('resize');	
});

$window.on('orientationchange', function() {
  $slider.slick('resize');
});